import services from './../../services/service'; // Service Class
// import SideScripts from './../Sidebar/script.js'; //Script call
import Yprompts from './../YPrompts/index.vue'
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
          user: '', 
          user_slug: {}
      }
  },
  components: {
    'prompts': Yprompts,
  },
  methods: {
    getUser() {
        let u = localStorage.getItem("cityneeds_user");
        if(u != null) {
            //let user = JSON.parse(u);
            //let fullname = user.user_fullname;
            this.user = u;
            this.user_slug = u.replace(" ", "_");
        }
    },

  },
  created: function() {
    this.getUser();
  }
}


// WEBPACK FOOTER //
// ./src/components/Main-Header/script.js